@if (windowScrolled) {
  <button class="btn-up" (click)="scrollTop()"></button>
}


